import "./index.css";
import React from "react";
import { Button } from "antd";

interface TypeStartSetupProps {
  onClick(): void;
}

const StartSetup: React.FC<TypeStartSetupProps> = ({ onClick }) => (
  <div className="website-start-setup">
    <h2>Launch Your Digital Presence</h2>
    <p>
      Capture leads from the marketplace and build credibility with a
      professional microsite.
    </p>
    <img src="/website.webp" alt="#" />
    <Button onClick={onClick} type="primary">
      Start setup
    </Button>
    <p>Takes about 3 minutes</p>
  </div>
);

export default StartSetup;
